import { useState } from 'react';
import { Box, Typography, styled, InputAdornment } from '@mui/material';
import Dialog, { DialogPrimaryButton } from '../Dialog';
import InputField from '../InputField';

const GiveBonusInputWrapper = styled(Box)({
  marginBottom: 30,
});

const GiveBonusDialog = ({ open, onClose, onSubmit }) => {
  const [amount, setAmount] = useState('');

  const handleClose = () => {
    setAmount('');
    onClose();
  };

  const handleSubmit = () => {
    onSubmit?.(amount);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} title="DONNER UN BONUS">
      <GiveBonusInputWrapper>
        <InputField
          label="Montant"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          type="number"
          fullWidth
          sx={{
            '& .MuiOutlinedInput-input': {
              '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                WebkitAppearance: 'none',
                margin: 0,
              },
              MozAppearance: 'textfield',
            },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end" sx={{ color: '#ACACAC' }}>
                <Typography sx={{ fontSize: 18, fontWeight: 500 }}>€</Typography>
              </InputAdornment>
            ),
          }}
        />
      </GiveBonusInputWrapper>
      <DialogPrimaryButton variant="contained" onClick={handleSubmit}>
        ATTRIBUER
      </DialogPrimaryButton>
    </Dialog>
  );
};

export default GiveBonusDialog;
